// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------Mixins------------------*/
.ml-0 {
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.mr-1 {
  margin-right: 4px !important;
}

.mt-1 {
  margin-top: 4px !important;
}

.mb-1 {
  margin-bottom: 4px !important;
}

.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ml-2 {
  margin-left: 8px !important;
}

.mr-2 {
  margin-right: 8px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.ml-3 {
  margin-left: 12px !important;
}

.mr-3 {
  margin-right: 12px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

.ml-4 {
  margin-left: 16px !important;
}

.mr-4 {
  margin-right: 16px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.ml-5 {
  margin-left: 20px !important;
}

.mr-5 {
  margin-right: 20px !important;
}

.mt-5 {
  margin-top: 20px !important;
}

.mb-5 {
  margin-bottom: 20px !important;
}

.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.ml-6 {
  margin-left: 24px !important;
}

.mr-6 {
  margin-right: 24px !important;
}

.mt-6 {
  margin-top: 24px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.ml-7 {
  margin-left: 28px !important;
}

.mr-7 {
  margin-right: 28px !important;
}

.mt-7 {
  margin-top: 28px !important;
}

.mb-7 {
  margin-bottom: 28px !important;
}

.mx-7 {
  margin-left: 28px !important;
  margin-right: 28px !important;
}

.my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

.ml-8 {
  margin-left: 32px !important;
}

.mr-8 {
  margin-right: 32px !important;
}

.mt-8 {
  margin-top: 32px !important;
}

.mb-8 {
  margin-bottom: 32px !important;
}

.mx-8 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

.ml-9 {
  margin-left: 36px !important;
}

.mr-9 {
  margin-right: 36px !important;
}

.mt-9 {
  margin-top: 36px !important;
}

.mb-9 {
  margin-bottom: 36px !important;
}

.mx-9 {
  margin-left: 36px !important;
  margin-right: 36px !important;
}

.my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

.ml-10 {
  margin-left: 40px !important;
}

.mr-10 {
  margin-right: 40px !important;
}

.mt-10 {
  margin-top: 40px !important;
}

.mb-10 {
  margin-bottom: 40px !important;
}

.mx-10 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.ml-11 {
  margin-left: 44px !important;
}

.mr-11 {
  margin-right: 44px !important;
}

.mt-11 {
  margin-top: 44px !important;
}

.mb-11 {
  margin-bottom: 44px !important;
}

.mx-11 {
  margin-left: 44px !important;
  margin-right: 44px !important;
}

.my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

.ml-12 {
  margin-left: 48px !important;
}

.mr-12 {
  margin-right: 48px !important;
}

.mt-12 {
  margin-top: 48px !important;
}

.mb-12 {
  margin-bottom: 48px !important;
}

.mx-12 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}

.my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

.ml-13 {
  margin-left: 52px !important;
}

.mr-13 {
  margin-right: 52px !important;
}

.mt-13 {
  margin-top: 52px !important;
}

.mb-13 {
  margin-bottom: 52px !important;
}

.mx-13 {
  margin-left: 52px !important;
  margin-right: 52px !important;
}

.my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

.ml-14 {
  margin-left: 56px !important;
}

.mr-14 {
  margin-right: 56px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mb-14 {
  margin-bottom: 56px !important;
}

.mx-14 {
  margin-left: 56px !important;
  margin-right: 56px !important;
}

.my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

.ml-15 {
  margin-left: 60px !important;
}

.mr-15 {
  margin-right: 60px !important;
}

.mt-15 {
  margin-top: 60px !important;
}

.mb-15 {
  margin-bottom: 60px !important;
}

.mx-15 {
  margin-left: 60px !important;
  margin-right: 60px !important;
}

.my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.ml-16 {
  margin-left: 64px !important;
}

.mr-16 {
  margin-right: 64px !important;
}

.mt-16 {
  margin-top: 64px !important;
}

.mb-16 {
  margin-bottom: 64px !important;
}

.mx-16 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}

.my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

.ml-17 {
  margin-left: 68px !important;
}

.mr-17 {
  margin-right: 68px !important;
}

.mt-17 {
  margin-top: 68px !important;
}

.mb-17 {
  margin-bottom: 68px !important;
}

.mx-17 {
  margin-left: 68px !important;
  margin-right: 68px !important;
}

.my-17 {
  margin-top: 68px !important;
  margin-bottom: 68px !important;
}

.ml-18 {
  margin-left: 72px !important;
}

.mr-18 {
  margin-right: 72px !important;
}

.mt-18 {
  margin-top: 72px !important;
}

.mb-18 {
  margin-bottom: 72px !important;
}

.mx-18 {
  margin-left: 72px !important;
  margin-right: 72px !important;
}

.my-18 {
  margin-top: 72px !important;
  margin-bottom: 72px !important;
}

.ml-19 {
  margin-left: 76px !important;
}

.mr-19 {
  margin-right: 76px !important;
}

.mt-19 {
  margin-top: 76px !important;
}

.mb-19 {
  margin-bottom: 76px !important;
}

.mx-19 {
  margin-left: 76px !important;
  margin-right: 76px !important;
}

.my-19 {
  margin-top: 76px !important;
  margin-bottom: 76px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.pl-1 {
  padding-left: 4px !important;
}

.pr-1 {
  padding-right: 4px !important;
}

.pt-1 {
  padding-top: 4px !important;
}

.pb-1 {
  padding-bottom: 4px !important;
}

.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pl-2 {
  padding-left: 8px !important;
}

.pr-2 {
  padding-right: 8px !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.pl-3 {
  padding-left: 12px !important;
}

.pr-3 {
  padding-right: 12px !important;
}

.pt-3 {
  padding-top: 12px !important;
}

.pb-3 {
  padding-bottom: 12px !important;
}

.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4 {
  padding-left: 16px !important;
}

.pr-4 {
  padding-right: 16px !important;
}

.pt-4 {
  padding-top: 16px !important;
}

.pb-4 {
  padding-bottom: 16px !important;
}

.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pl-5 {
  padding-left: 20px !important;
}

.pr-5 {
  padding-right: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pb-5 {
  padding-bottom: 20px !important;
}

.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.pl-6 {
  padding-left: 24px !important;
}

.pr-6 {
  padding-right: 24px !important;
}

.pt-6 {
  padding-top: 24px !important;
}

.pb-6 {
  padding-bottom: 24px !important;
}

.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.pl-7 {
  padding-left: 28px !important;
}

.pr-7 {
  padding-right: 28px !important;
}

.pt-7 {
  padding-top: 28px !important;
}

.pb-7 {
  padding-bottom: 28px !important;
}

.px-7 {
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

.pl-8 {
  padding-left: 32px !important;
}

.pr-8 {
  padding-right: 32px !important;
}

.pt-8 {
  padding-top: 32px !important;
}

.pb-8 {
  padding-bottom: 32px !important;
}

.px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.pl-9 {
  padding-left: 36px !important;
}

.pr-9 {
  padding-right: 36px !important;
}

.pt-9 {
  padding-top: 36px !important;
}

.pb-9 {
  padding-bottom: 36px !important;
}

.px-9 {
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

.pl-10 {
  padding-left: 40px !important;
}

.pr-10 {
  padding-right: 40px !important;
}

.pt-10 {
  padding-top: 40px !important;
}

.pb-10 {
  padding-bottom: 40px !important;
}

.px-10 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pl-11 {
  padding-left: 44px !important;
}

.pr-11 {
  padding-right: 44px !important;
}

.pt-11 {
  padding-top: 44px !important;
}

.pb-11 {
  padding-bottom: 44px !important;
}

.px-11 {
  padding-left: 44px !important;
  padding-right: 44px !important;
}

.py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

.pl-12 {
  padding-left: 48px !important;
}

.pr-12 {
  padding-right: 48px !important;
}

.pt-12 {
  padding-top: 48px !important;
}

.pb-12 {
  padding-bottom: 48px !important;
}

.px-12 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}

.py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.pl-13 {
  padding-left: 52px !important;
}

.pr-13 {
  padding-right: 52px !important;
}

.pt-13 {
  padding-top: 52px !important;
}

.pb-13 {
  padding-bottom: 52px !important;
}

.px-13 {
  padding-left: 52px !important;
  padding-right: 52px !important;
}

.py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

.pl-14 {
  padding-left: 56px !important;
}

.pr-14 {
  padding-right: 56px !important;
}

.pt-14 {
  padding-top: 56px !important;
}

.pb-14 {
  padding-bottom: 56px !important;
}

.px-14 {
  padding-left: 56px !important;
  padding-right: 56px !important;
}

.py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

.pl-15 {
  padding-left: 60px !important;
}

.pr-15 {
  padding-right: 60px !important;
}

.pt-15 {
  padding-top: 60px !important;
}

.pb-15 {
  padding-bottom: 60px !important;
}

.px-15 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.pl-16 {
  padding-left: 64px !important;
}

.pr-16 {
  padding-right: 64px !important;
}

.pt-16 {
  padding-top: 64px !important;
}

.pb-16 {
  padding-bottom: 64px !important;
}

.px-16 {
  padding-left: 64px !important;
  padding-right: 64px !important;
}

.py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.pl-17 {
  padding-left: 68px !important;
}

.pr-17 {
  padding-right: 68px !important;
}

.pt-17 {
  padding-top: 68px !important;
}

.pb-17 {
  padding-bottom: 68px !important;
}

.px-17 {
  padding-left: 68px !important;
  padding-right: 68px !important;
}

.py-17 {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}

.pl-18 {
  padding-left: 72px !important;
}

.pr-18 {
  padding-right: 72px !important;
}

.pt-18 {
  padding-top: 72px !important;
}

.pb-18 {
  padding-bottom: 72px !important;
}

.px-18 {
  padding-left: 72px !important;
  padding-right: 72px !important;
}

.py-18 {
  padding-top: 72px !important;
  padding-bottom: 72px !important;
}

.pl-19 {
  padding-left: 76px !important;
}

.pr-19 {
  padding-right: 76px !important;
}

.pt-19 {
  padding-top: 76px !important;
}

.pb-19 {
  padding-bottom: 76px !important;
}

.px-19 {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.py-19 {
  padding-top: 76px !important;
  padding-bottom: 76px !important;
}

.mnavbar {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  min-height: 86px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #ffffff;
  padding: 8px 0px;
  z-index: 99;
}
.mnavbar .hamburger-menu {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background: #1E2E5F;
  border-radius: 50%;
}

.MuiDrawer-root .MuiPaper-root {
  min-width: 60%;
  max-width: 60%;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper {
  position: relative;
  min-height: 100vh;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .top-sec {
  background: #1E2E5F;
  padding: 16px 4px;
  margin-bottom: 8px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .top-sec .user_box {
  padding: 8px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 100px;
  display: flex;
  gap: 12px;
  align-items: center;
  background: #ffffff;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .top-sec .user_box img {
  width: 36px;
  height: 36px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .top-sec .user_box p {
  color: #000000;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-heading {
  padding: 8px 0px;
  font-size: 12px;
  line-height: 18px;
  border-bottom: 1px solid #E9F1FD;
  color: rgb(255, 243, 244);
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .dash-link {
  padding: 4px 0px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .dash-link img {
  width: 30px;
  height: 30px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .dash-link span {
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  color: #ffffff;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .dash-link-login {
  padding: 4px 0px;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  border: 1px solid #ffffff;
  width: 100%;
  padding: 8px;
  border-radius: 100px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .dash-link-login img {
  width: 30px;
  height: 30px;
  border: 1px solid #ffffff;
  border-radius: 50%;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .dash-link-login span {
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  color: #ffffff;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section {
  padding: 12px 16px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li {
  padding: 8px 0;
  border-bottom: 1px solid #E9F1FD;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li:last-child {
  border-bottom: none;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .nav-link {
  text-decoration: none;
  color: #000;
  font-size: 0.875rem;
  line-height: 28px;
  cursor: pointer;
  padding: 2px 0px;
  display: inline-flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  font-weight: 500;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .nav-link-inner {
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 6px;
  display: block;
  color: #1E2E5F;
  padding: 2px 0px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .subMenu-innerlink {
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 6px;
  display: block;
  color: #BE2532;
  padding: 2px 0px;
  font-weight: 400;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .subMenu-innerlink:last-child {
  margin-bottom: 0;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .MuiCollapse-root {
  margin-top: 4px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .mainMenusec {
  padding: 8px;
  background: #E9F1FD;
  border-radius: 10px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .subMenusec {
  padding: 8px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  margin-bottom: 8px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .ca-link {
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-flex;
  padding: 8px 16px;
  border-radius: 30px;
  position: relative;
  background: #BE2532;
  width: 100%;
  justify-content: center;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .ca-link:hover {
  color: #ffffff;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .ca-link span {
  position: absolute;
  top: -8px;
  right: 12px;
  border-radius: 30px;
  background: #F8E007;
  color: #000000;
  padding: 2px 8px;
  display: inline;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .ca-link span p {
  font-size: 0.5625rem;
  font-weight: 600;
  line-height: 10px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .ca-link span .blink_text {
  animation-name: blinker;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .ca-link span.boxblink {
  animation-name: boxblinker;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  transition: all ease-in-out 1s;
}
@keyframes blinker {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes boxblinker {
  0% {
    scale: 1;
  }
  50% {
    scale: 0.8;
  }
  100% {
    scale: 1;
  }
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .pir-link {
  background: #1E2E5F;
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-flex;
  padding: 8px 16px;
  border-radius: 30px;
  border: none;
  width: 100%;
  justify-content: center;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .pir-link:hover {
  color: #ffffff;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .logo-link {
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-flex;
  padding: 6px 16px;
  border-radius: 30px;
  position: relative;
  outline: 1px solid #1E2E5F;
  outline-offset: -1px;
  width: 100%;
  justify-content: center;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .logo-link img {
  height: 25px;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .login {
  text-decoration: none;
  font-size: 0.875rem;
  line-height: 21px;
  color: #ffffff;
  display: inline-block;
  padding: 8px 16px;
  border-radius: 30px;
  position: relative;
  background: rgb(196, 61, 73);
  width: 100%;
  text-align: center;
}
.MuiDrawer-root .MuiPaper-root .menuWrapper .menu-section ul li .login:hover {
  color: rgb(196, 61, 73);
  outline: 1px solid rgb(196, 61, 73);
  outline-offset: -1px;
  background: transparent;
}

.MuiBackdrop-root {
  background: rgba(0, 0, 0, 0.15) !important;
}`, "",{"version":3,"sources":["webpack://./src/SCSS/Mixins.scss","webpack://./src/Components/Mobile/MNavBar/MNavbar.scss"],"names":[],"mappings":"AAWA,yCAAA;AAoDI;EACI,2BAAA;AC7DR;;ADgEI;EACI,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;AC7DR;;ADgEI;EACI,6BAAA;AC7DR;;ADgEI;EACI,2BAAA;EACA,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;EACA,6BAAA;AC7DR;;ADsCI;EACI,2BAAA;ACnCR;;ADsCI;EACI,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;ACnCR;;ADsCI;EACI,6BAAA;ACnCR;;ADsCI;EACI,2BAAA;EACA,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;EACA,6BAAA;ACnCR;;ADYI;EACI,2BAAA;ACTR;;ADYI;EACI,4BAAA;ACTR;;ADYI;EACI,0BAAA;ACTR;;ADYI;EACI,6BAAA;ACTR;;ADYI;EACI,2BAAA;EACA,4BAAA;ACTR;;ADYI;EACI,0BAAA;EACA,6BAAA;ACTR;;ADdI;EACI,4BAAA;ACiBR;;ADdI;EACI,6BAAA;ACiBR;;ADdI;EACI,2BAAA;ACiBR;;ADdI;EACI,8BAAA;ACiBR;;ADdI;EACI,4BAAA;EACA,6BAAA;ACiBR;;ADdI;EACI,2BAAA;EACA,8BAAA;ACiBR;;ADxCI;EACI,4BAAA;AC2CR;;ADxCI;EACI,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;AC2CR;;ADxCI;EACI,8BAAA;AC2CR;;ADxCI;EACI,4BAAA;EACA,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;EACA,8BAAA;AC2CR;;ADlEI;EACI,4BAAA;ACqER;;ADlEI;EACI,6BAAA;ACqER;;ADlEI;EACI,2BAAA;ACqER;;ADlEI;EACI,8BAAA;ACqER;;ADlEI;EACI,4BAAA;EACA,6BAAA;ACqER;;ADlEI;EACI,2BAAA;EACA,8BAAA;ACqER;;AD5FI;EACI,4BAAA;AC+FR;;AD5FI;EACI,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;AC+FR;;AD5FI;EACI,8BAAA;AC+FR;;AD5FI;EACI,4BAAA;EACA,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;EACA,8BAAA;AC+FR;;ADtHI;EACI,4BAAA;ACyHR;;ADtHI;EACI,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;ACyHR;;ADtHI;EACI,8BAAA;ACyHR;;ADtHI;EACI,4BAAA;EACA,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;EACA,8BAAA;ACyHR;;ADhJI;EACI,4BAAA;ACmJR;;ADhJI;EACI,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;ACmJR;;ADhJI;EACI,8BAAA;ACmJR;;ADhJI;EACI,4BAAA;EACA,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;EACA,8BAAA;ACmJR;;AD1KI;EACI,4BAAA;AC6KR;;AD1KI;EACI,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;AC6KR;;AD1KI;EACI,8BAAA;AC6KR;;AD1KI;EACI,4BAAA;EACA,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;EACA,8BAAA;AC6KR;;ADpMI;EACI,4BAAA;ACuMR;;ADpMI;EACI,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;ACuMR;;ADpMI;EACI,8BAAA;ACuMR;;ADpMI;EACI,4BAAA;EACA,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;EACA,8BAAA;ACuMR;;AD9NI;EACI,4BAAA;ACiOR;;AD9NI;EACI,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;ACiOR;;AD9NI;EACI,8BAAA;ACiOR;;AD9NI;EACI,4BAAA;EACA,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;EACA,8BAAA;ACiOR;;ADxPI;EACI,4BAAA;AC2PR;;ADxPI;EACI,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;AC2PR;;ADxPI;EACI,8BAAA;AC2PR;;ADxPI;EACI,4BAAA;EACA,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;EACA,8BAAA;AC2PR;;ADlRI;EACI,4BAAA;ACqRR;;ADlRI;EACI,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;ACqRR;;ADlRI;EACI,8BAAA;ACqRR;;ADlRI;EACI,4BAAA;EACA,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;EACA,8BAAA;ACqRR;;AD5SI;EACI,4BAAA;AC+SR;;AD5SI;EACI,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;AC+SR;;AD5SI;EACI,8BAAA;AC+SR;;AD5SI;EACI,4BAAA;EACA,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;EACA,8BAAA;AC+SR;;ADtUI;EACI,4BAAA;ACyUR;;ADtUI;EACI,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;ACyUR;;ADtUI;EACI,8BAAA;ACyUR;;ADtUI;EACI,4BAAA;EACA,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;EACA,8BAAA;ACyUR;;ADhWI;EACI,4BAAA;ACmWR;;ADhWI;EACI,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;ACmWR;;ADhWI;EACI,8BAAA;ACmWR;;ADhWI;EACI,4BAAA;EACA,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;EACA,8BAAA;ACmWR;;AD1XI;EACI,4BAAA;AC6XR;;AD1XI;EACI,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;AC6XR;;AD1XI;EACI,8BAAA;AC6XR;;AD1XI;EACI,4BAAA;EACA,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;EACA,8BAAA;AC6XR;;ADpZI;EACI,4BAAA;ACuZR;;ADpZI;EACI,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;ACuZR;;ADpZI;EACI,8BAAA;ACuZR;;ADpZI;EACI,4BAAA;EACA,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;EACA,8BAAA;ACuZR;;AD9aI;EACI,4BAAA;ACibR;;AD9aI;EACI,6BAAA;ACibR;;AD9aI;EACI,2BAAA;ACibR;;AD9aI;EACI,8BAAA;ACibR;;AD9aI;EACI,4BAAA;EACA,6BAAA;ACibR;;AD9aI;EACI,2BAAA;EACA,8BAAA;ACibR;;AD3aI;EACI,4BAAA;AC8aR;;AD3aI;EACI,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;AC8aR;;AD3aI;EACI,8BAAA;AC8aR;;AD3aI;EACI,4BAAA;EACA,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;EACA,8BAAA;AC8aR;;ADrcI;EACI,4BAAA;ACwcR;;ADrcI;EACI,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;ACwcR;;ADrcI;EACI,8BAAA;ACwcR;;ADrcI;EACI,4BAAA;EACA,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;EACA,8BAAA;ACwcR;;AD/dI;EACI,4BAAA;ACkeR;;AD/dI;EACI,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;ACkeR;;AD/dI;EACI,8BAAA;ACkeR;;AD/dI;EACI,4BAAA;EACA,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;EACA,8BAAA;ACkeR;;ADzfI;EACI,6BAAA;AC4fR;;ADzfI;EACI,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;AC4fR;;ADzfI;EACI,+BAAA;AC4fR;;ADzfI;EACI,6BAAA;EACA,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;EACA,+BAAA;AC4fR;;ADnhBI;EACI,6BAAA;ACshBR;;ADnhBI;EACI,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;ACshBR;;ADnhBI;EACI,+BAAA;ACshBR;;ADnhBI;EACI,6BAAA;EACA,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;EACA,+BAAA;ACshBR;;AD7iBI;EACI,6BAAA;ACgjBR;;AD7iBI;EACI,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;ACgjBR;;AD7iBI;EACI,+BAAA;ACgjBR;;AD7iBI;EACI,6BAAA;EACA,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;EACA,+BAAA;ACgjBR;;ADvkBI;EACI,6BAAA;AC0kBR;;ADvkBI;EACI,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;AC0kBR;;ADvkBI;EACI,+BAAA;AC0kBR;;ADvkBI;EACI,6BAAA;EACA,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;EACA,+BAAA;AC0kBR;;ADjmBI;EACI,6BAAA;AComBR;;ADjmBI;EACI,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;AComBR;;ADjmBI;EACI,+BAAA;AComBR;;ADjmBI;EACI,6BAAA;EACA,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;EACA,+BAAA;AComBR;;AD3nBI;EACI,6BAAA;AC8nBR;;AD3nBI;EACI,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;AC8nBR;;AD3nBI;EACI,+BAAA;AC8nBR;;AD3nBI;EACI,6BAAA;EACA,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;EACA,+BAAA;AC8nBR;;ADrpBI;EACI,6BAAA;ACwpBR;;ADrpBI;EACI,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;ACwpBR;;ADrpBI;EACI,+BAAA;ACwpBR;;ADrpBI;EACI,6BAAA;EACA,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;EACA,+BAAA;ACwpBR;;AD/qBI;EACI,6BAAA;ACkrBR;;AD/qBI;EACI,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;ACkrBR;;AD/qBI;EACI,+BAAA;ACkrBR;;AD/qBI;EACI,6BAAA;EACA,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;EACA,+BAAA;ACkrBR;;ADzsBI;EACI,6BAAA;AC4sBR;;ADzsBI;EACI,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;AC4sBR;;ADzsBI;EACI,+BAAA;AC4sBR;;ADzsBI;EACI,6BAAA;EACA,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;EACA,+BAAA;AC4sBR;;ADnuBI;EACI,6BAAA;ACsuBR;;ADnuBI;EACI,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;ACsuBR;;ADnuBI;EACI,+BAAA;ACsuBR;;ADnuBI;EACI,6BAAA;EACA,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;EACA,+BAAA;ACsuBR;;AD7vBI;EACI,6BAAA;ACgwBR;;AD7vBI;EACI,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;ACgwBR;;AD7vBI;EACI,+BAAA;ACgwBR;;AD7vBI;EACI,6BAAA;EACA,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;EACA,+BAAA;ACgwBR;;ADvxBI;EACI,6BAAA;AC0xBR;;ADvxBI;EACI,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;AC0xBR;;ADvxBI;EACI,+BAAA;AC0xBR;;ADvxBI;EACI,6BAAA;EACA,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;EACA,+BAAA;AC0xBR;;ADjzBI;EACI,6BAAA;ACozBR;;ADjzBI;EACI,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;ACozBR;;ADjzBI;EACI,+BAAA;ACozBR;;ADjzBI;EACI,6BAAA;EACA,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;EACA,+BAAA;ACozBR;;AD30BI;EACI,6BAAA;AC80BR;;AD30BI;EACI,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;AC80BR;;AD30BI;EACI,+BAAA;AC80BR;;AD30BI;EACI,6BAAA;EACA,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;EACA,+BAAA;AC80BR;;ADr2BI;EACI,6BAAA;ACw2BR;;ADr2BI;EACI,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;ACw2BR;;ADr2BI;EACI,+BAAA;ACw2BR;;ADr2BI;EACI,6BAAA;EACA,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;EACA,+BAAA;ACw2BR;;AD/3BI;EACI,6BAAA;ACk4BR;;AD/3BI;EACI,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;ACk4BR;;AD/3BI;EACI,+BAAA;ACk4BR;;AD/3BI;EACI,6BAAA;EACA,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;EACA,+BAAA;ACk4BR;;ADz5BI;EACI,6BAAA;AC45BR;;ADz5BI;EACI,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;AC45BR;;ADz5BI;EACI,+BAAA;AC45BR;;ADz5BI;EACI,6BAAA;EACA,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;EACA,+BAAA;AC45BR;;AA7gCA;EACI,2CAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,mBDLI;ECMJ,gBAAA;EACA,WAAA;AAghCJ;AA9gCI;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBDlBE;ECmBF,kBAAA;AAghCR;;AA1gCI;EACI,cAAA;EACA,cAAA;AA6gCR;AA3gCQ;EACI,kBAAA;EACA,iBAAA;AA6gCZ;AA3gCY;EACI,mBDlCN;ECmCM,iBAAA;EACA,kBAAA;AA6gChB;AA3gCgB;EACI,YAAA;EACA,2CAAA;EACA,oBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBD1CZ;ACujCR;AA3gCoB;EACI,WAAA;EACA,YAAA;AA6gCxB;AA1gCoB;EACI,cDnDhB;AC+jCR;AAvgCY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,yBAAA;AAygChB;AAtgCY;EACI,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AAwgChB;AAtgCgB;EACI,WAAA;EACA,YAAA;AAwgCpB;AArgCgB;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cD/EZ;ACslCR;AAngCY;EACI,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AAqgChB;AAngCgB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAqgCpB;AAlgCgB;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDzGZ;AC6mCR;AAhgCY;EACI,kBAAA;AAkgChB;AA//BoB;EACI,cAAA;EACA,gCAAA;AAigCxB;AA//BwB;EACI,mBAAA;AAigC5B;AA9/BwB;EACI,qBAAA;EACA,WAAA;ED1FxB,mBAAA;EC4FwB,iBAAA;EAEA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,gBAAA;AAggC5B;AA7/BwB;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,cDhJlB;ECiJkB,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AA+/B5B;AA5/BwB;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,cD7JhB;EC8JgB,gBAAA;EACA,gBAAA;AA8/B5B;AA5/B4B;EACI,gBAAA;AA8/BhC;AA1/BwB;EACI,eAAA;AA4/B5B;AAz/BwB;EACI,YAAA;EACA,mBDtKjB;ECuKiB,mBAAA;AA2/B5B;AAx/BwB;EACI,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;AA0/B5B;AAv/BwB;EACI,qBAAA;EDvJxB,mBAAA;ECyJwB,iBAAA;EACA,cD3LpB;EC4LoB,oBAAA;EACA,iBAAA;ED5KxB,mBC6K+C;EACvB,kBAAA;EACA,mBDlMhB;ECmMgB,WAAA;EACA,uBAAA;AA2/B5B;AAz/B4B;EACI,cDrMxB;ACgsCR;AAx/B4B;ED/JxB,kBCgK8C;ED/J9C,SC+J8D;ED9J9D,WC8J4E;EDxL5E,mBCyLmD;EACvB,mBAAA;EACA,cD7MxB;EC8MwB,gBAAA;EACA,eAAA;AA8/BhC;AA5/BgC;ED/K5B,oBAAA;ECiLgC,gBAAA;EACA,iBAAA;AA8/BpC;AA3/BgC;EACI,uBAAA;EACA,sBAAA;EACA,iCAAA;EACA,mCAAA;AA6/BpC;AA1/BgC;EACI,0BAAA;EACA,sBAAA;EACA,iCAAA;EACA,mCAAA;EACA,8BAAA;AA4/BpC;AAz/BgC;EACI;IACI,UAAA;EA2/BtC;EAx/BkC;IACI,YAAA;EA0/BtC;EAv/BkC;IACI,UAAA;EAy/BtC;AACF;AAt/BgC;EACI;IACI,QAAA;EAw/BtC;EAr/BkC;IACI,UAAA;EAu/BtC;EAp/BkC;IACI,QAAA;EAs/BtC;AACF;AAj/BwB;EACI,mBDvQlB;ECwQkB,qBAAA;EDpOxB,mBAAA;ECsOwB,iBAAA;EACA,cDxQpB;ECyQoB,oBAAA;EACA,iBAAA;EDzPxB,mBC0P+C;EACvB,YAAA;EACA,WAAA;EACA,uBAAA;AAq/B5B;AAn/B4B;EACI,cDjRxB;ACswCR;AAj/BwB;EACI,qBAAA;EDrPxB,mBAAA;ECuPwB,iBAAA;EACA,cDzRpB;EC0RoB,oBAAA;EACA,iBAAA;ED1QxB,mBC2Q+C;EACvB,kBAAA;EACA,0BAAA;EACA,oBAAA;EACA,WAAA;EACA,uBAAA;AAq/B5B;AAn/B4B;EACI,YAAA;AAq/BhC;AAh/BwB;EACI,qBAAA;EDzQxB,mBAAA;EC2QwB,iBAAA;EACA,cD7SpB;EC8SoB,qBAAA;EACA,iBAAA;ED9RxB,mBC+R+C;EACvB,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,kBAAA;AAo/B5B;AAl/B4B;EACI,uBAAA;EACA,mCAAA;EACA,oBAAA;EACA,uBAAA;AAo/BhC;;AAz+BA;EACI,0CAAA;AA4+BJ","sourcesContent":["// Color Variables\n$primary: #1E2E5F;\n$secondary: #BE2532;\n$black: #000000;\n$white: #ffffff;\n$grey: #808080;\n$red: #D9132E;\n$lightbg: #fbfbfb;\n$lightblue:#E9F1FD;\n\n\n/*--------------Mixins------------------*/\n@mixin box-shadow($shadow) {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n}\n\n@mixin border-radius($radius: none) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    border-radius: $radius;\n}\n\n@mixin appearance() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@function calculateRem($size) {\n    $remSize: $size / 16px;\n    @return #{$remSize}rem;\n}\n\n@mixin fontSize($size) {\n    //font-size: $size;\n    font-size: calculateRem($size);\n}\n\n@mixin position($position,\n    $top: null,\n    $right: null,\n    $bottom: null,\n    $left: null) {\n    position: $position;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    // @include abs-position(10px, 10px, auto, auto);\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n// Margins\n@for $i from 0 to 20 {\n    .ml-#{$i} {\n        margin-left: 4px * $i !important;\n    }\n\n    .mr-#{$i} {\n        margin-right: 4px * $i !important;\n    }\n\n    .mt-#{$i} {\n        margin-top: 4px * $i !important;\n    }\n\n    .mb-#{$i} {\n        margin-bottom: 4px * $i !important;\n    }\n\n    .mx-#{$i} {\n        margin-left: 4px * $i !important;\n        margin-right: 4px * $i !important;\n    }\n\n    .my-#{$i} {\n        margin-top: 4px * $i !important;\n        margin-bottom: 4px * $i !important;\n    }\n}\n\n// Paddings\n@for $i from 0 to 20 {\n    .pl-#{$i} {\n        padding-left: 4px * $i !important;\n    }\n\n    .pr-#{$i} {\n        padding-right: 4px * $i !important;\n    }\n\n    .pt-#{$i} {\n        padding-top: 4px * $i !important;\n    }\n\n    .pb-#{$i} {\n        padding-bottom: 4px * $i !important;\n    }\n\n    .px-#{$i} {\n        padding-left: 4px * $i !important;\n        padding-right: 4px * $i !important;\n    }\n\n    .py-#{$i} {\n        padding-top: 4px * $i !important;\n        padding-bottom: 4px * $i !important;\n    }\n}","@import \"./../../../SCSS/Mixins.scss\";\n\n.mnavbar {\n    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);\n    min-height: 86px;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    background: $white;\n    padding: 8px 0px;\n    z-index: 99;\n\n    .hamburger-menu {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        width: 32px;\n        height: 32px;\n        background: $primary;\n        border-radius: 50%;\n    }\n}\n\n// sidemenu css\n.MuiDrawer-root {\n    .MuiPaper-root {\n        min-width: 60%;\n        max-width: 60%;\n\n        .menuWrapper {\n            position: relative;\n            min-height: 100vh;\n\n            .top-sec {\n                background: $primary;\n                padding: 16px 4px;\n                margin-bottom: 8px;\n\n                .user_box {\n                    padding: 8px;\n                    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);\n                    border-radius: 100px;\n                    display: flex;\n                    gap: 12px;\n                    align-items: center;\n                    background: $white;\n\n                    img {\n                        width: 36px;\n                        height: 36px;\n                    }\n\n                    p {\n                        color: $black;\n                    }\n                }\n            }\n\n            .menu-heading {\n                padding: 8px 0px;\n                font-size: 12px;\n                line-height: 18px;\n                border-bottom: 1px solid $lightblue;\n                color: rgba(255, 243, 244, 1);\n            }\n\n            .dash-link {\n                padding: 4px 0px;\n                display: inline-flex;\n                align-items: center;\n                gap: 12px;\n                width: 100%;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                }\n\n                span {\n                    font-size: 14px;\n                    line-height: 21px;\n                    font-weight: 500;\n                    color: $white;\n                }\n            }\n\n            .dash-link-login {\n                padding: 4px 0px;\n                display: inline-flex;\n                align-items: center;\n                gap: 12px;\n                justify-content: center;\n                border: 1px solid $white;\n                width: 100%;\n                padding: 8px;\n                border-radius: 100px;\n\n                img {\n                    width: 30px;\n                    height: 30px;\n                    border: 1px solid $white;\n                    border-radius: 50%;\n                }\n\n                span {\n                    font-size: 14px;\n                    line-height: 21px;\n                    font-weight: 500;\n                    color: $white;\n                }\n            }\n\n            .menu-section {\n                padding: 12px 16px;\n\n                ul {\n                    li {\n                        padding: 8px 0;\n                        border-bottom: 1px solid $lightblue;\n\n                        &:last-child {\n                            border-bottom: none;\n                        }\n\n                        .nav-link {\n                            text-decoration: none;\n                            color: #000;\n                            @include fontSize(14px);\n                            line-height: 28px;\n                            font-weight: 400;\n                            cursor: pointer;\n                            padding: 2px 0px;\n                            display: inline-flex;\n                            align-items: center;\n                            width: 100%;\n                            justify-content: space-between;\n                            font-weight: 500;\n                        }\n\n                        .nav-link-inner {\n                            font-size: 13px;\n                            line-height: 18px;\n                            margin-bottom: 6px;\n                            display: block;\n                            color: $primary;\n                            padding: 2px 0px;\n                            font-weight: 500;\n                            display: inline-flex;\n                            align-items: center;\n                            width: 100%;\n                            justify-content: space-between;\n                        }\n\n                        .subMenu-innerlink {\n                            font-size: 12px;\n                            line-height: 16px;\n                            margin-bottom: 6px;\n                            display: block;\n                            color: $secondary;\n                            padding: 2px 0px;\n                            font-weight: 400;\n\n                            &:last-child {\n                                margin-bottom: 0;\n                            }\n                        }\n\n                        .MuiCollapse-root {\n                            margin-top: 4px;\n                        }\n\n                        .mainMenusec {\n                            padding: 8px;\n                            background: $lightblue;\n                            border-radius: 10px;\n                        }\n\n                        .subMenusec {\n                            padding: 8px;\n                            border-radius: 10px;\n                            background: rgba(255, 255, 255, 0.4);\n                            box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n                            backdrop-filter: blur(5px);\n                            margin-bottom: 8px;\n                        }\n\n                        .ca-link {\n                            text-decoration: none;\n                            @include fontSize(14px);\n                            line-height: 21px;\n                            color: $white;\n                            display: inline-flex;\n                            padding: 8px 16px;\n                            @include border-radius(30px);\n                            position: relative;\n                            background: $secondary;\n                            width: 100%;\n                            justify-content: center;\n\n                            &:hover {\n                                color: $white;\n                            }\n\n                            span {\n                                @include position(absolute, $top: -8px, $right: 12px);\n                                @include border-radius(30px);\n                                background: #F8E007;\n                                color: $black;\n                                padding: 2px 8px;\n                                display: inline;\n\n                                p {\n                                    @include fontSize(9px);\n                                    font-weight: 600;\n                                    line-height: 10px;\n                                }\n\n                                .blink_text {\n                                    animation-name: blinker;\n                                    animation-duration: 1s;\n                                    animation-timing-function: linear;\n                                    animation-iteration-count: infinite;\n                                }\n\n                                &.boxblink {\n                                    animation-name: boxblinker;\n                                    animation-duration: 1s;\n                                    animation-timing-function: linear;\n                                    animation-iteration-count: infinite;\n                                    transition: all ease-in-out 1s;\n                                }\n\n                                @keyframes blinker {\n                                    0% {\n                                        opacity: 1.0;\n                                    }\n\n                                    50% {\n                                        opacity: 0.1;\n                                    }\n\n                                    100% {\n                                        opacity: 1.0;\n                                    }\n                                }\n\n                                @keyframes boxblinker {\n                                    0% {\n                                        scale: 1;\n                                    }\n\n                                    50% {\n                                        scale: 0.8;\n                                    }\n\n                                    100% {\n                                        scale: 1;\n                                    }\n                                }\n                            }\n                        }\n\n                        .pir-link {\n                            background: $primary;\n                            text-decoration: none;\n                            @include fontSize(14px);\n                            line-height: 21px;\n                            color: $white;\n                            display: inline-flex;\n                            padding: 8px 16px;\n                            @include border-radius(30px);\n                            border: none;\n                            width: 100%;\n                            justify-content: center;\n\n                            &:hover {\n                                color: $white;\n                            }\n                        }\n\n                        .logo-link {\n                            text-decoration: none;\n                            @include fontSize(14px);\n                            line-height: 21px;\n                            color: $white;\n                            display: inline-flex;\n                            padding: 6px 16px;\n                            @include border-radius(30px);\n                            position: relative;\n                            outline: 1px solid $primary;\n                            outline-offset: -1px;\n                            width: 100%;\n                            justify-content: center;\n\n                            img {\n                                height: 25px\n                            }\n\n                        }\n\n                        .login {\n                            text-decoration: none;\n                            @include fontSize(14px);\n                            line-height: 21px;\n                            color: $white;\n                            display: inline-block;\n                            padding: 8px 16px;\n                            @include border-radius(30px);\n                            position: relative;\n                            background: rgba(196, 61, 73, 1);\n                            width: 100%;\n                            text-align: center;\n\n                            &:hover {\n                                color: rgba(196, 61, 73, 1);\n                                outline: 1px solid rgba(196, 61, 73, 1);\n                                outline-offset: -1px;\n                                background: transparent;\n                            }\n\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.MuiBackdrop-root {\n    background: rgba(0, 0, 0, 0.15) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
